document.addEventListener("DOMContentLoaded", () => {
    const neighbourhoodSelect = document.getElementById("neighbourhood");
    const analysisData = document.getElementById("analysis-data");
    const loadingIndicator = document.getElementById("loading");

    const selectDisplay = $('#neighbourhood-select .custom-select-display');
    const selectOptions = $('#neighbourhood-select .custom-select-options');
    const selectedNeighbourhood = $('#selected-neighbourhood');


    function parameterize(str) {
        return str
            .toLowerCase()
            .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }


    function updateURL(name) {
        if (!name || name === "Cijeli grad") {
            const newUrl = window.location.pathname;
            window.history.pushState({}, '', newUrl);
        } else {
            const paramName = parameterize(name);
            const newUrl = `${window.location.pathname}?kvart=${paramName}`;
            window.history.pushState({}, '', newUrl);
        }
    }

    function highlightSelected(neighbourhoodId) {
        $('.neighbourhood-item').removeClass('selected');
        if (neighbourhoodId) {
            $(`.neighbourhood-item[data-id="${neighbourhoodId}"]`).addClass('selected');
        } else {

            $(`.neighbourhood-item[data-id=""]`).addClass('selected');
        }
    }


    function scrollToSelector() {
        const selector = document.getElementById('neighbourhood-select');
        if (selector) {
            setTimeout(() => {

                const yOffset = -30;
                const y = selector.getBoundingClientRect().top + window.pageYOffset + yOffset;

                window.scrollTo({
                    top: y,
                    behavior: 'smooth'
                });
            }, 300);
        }
    }


    function fetchAnalysisData(neighbourhoodId, neighbourhoodName, shouldScroll = false) {

        if (!neighbourhoodId || neighbourhoodId === "") {
            window.location.href = window.location.pathname;
            return;
        }

        if (shouldScroll) {
            scrollToSelector();
        }


        $('#analysis-data').addClass('loading');
        $('#loading').removeClass('hidden');


        updateURL(neighbourhoodName);


        highlightSelected(neighbourhoodId);

        fetch(`/hr/sto-s-otpadom?neighbourhood_id=${neighbourhoodId || ''}`, {
            headers: { "X-Requested-With": "XMLHttpRequest" }
        })
            .then(response => response.text())
            .then(html => {
                analysisData.innerHTML = html;
                $('#analysis-data').removeClass('loading');
                $('#loading').addClass('hidden');


                if (typeof initializeCharts === 'function') {
                    initializeCharts();
                }
            })
            .catch(error => console.error("Error:", error));
    }


    selectDisplay.on("click", function () {
        if (selectOptions.css('display') === 'none') {
            selectOptions.css('display', 'block');
        } else {
            selectOptions.css('display', 'none');
        }
        selectDisplay.toggleClass("is-active");
    });

    $(document).on('click', function (event) {
        if (
            !$(event.target).closest(selectDisplay).length &&
            !$(event.target).closest(selectOptions).length
        ) {
            selectOptions.css('display', 'none');
            selectDisplay.removeClass('is-active');
        }
    });


    $('.custom-select-option').click(function () {
        const neighbourhoodName = $(this).text().trim();
        const neighbourhoodId = $(this).data('id');

        selectedNeighbourhood.text(neighbourhoodName);
        selectOptions.css('display', 'none');
        selectDisplay.removeClass("is-active");


        fetchAnalysisData(neighbourhoodId, neighbourhoodName, false);
    });


    $('.neighbourhood-item').click(function () {
        const neighbourhoodId = $(this).data('id');
        const neighbourhoodName = $(this).text().trim();


        selectedNeighbourhood.text(neighbourhoodName);


        fetchAnalysisData(neighbourhoodId, neighbourhoodName, true);
    });


    const urlParams = new URLSearchParams(window.location.search);
    const kvart = urlParams.get('kvart');

    if (kvart) {
        let found = false;
        $('.neighbourhood-item').each(function () {
            const name = $(this).text().trim();
            const paramName = parameterize(name);

            if (paramName === kvart) {
                found = true;
                const neighbourhoodId = $(this).data('id');
                const neighbourhoodName = name;


                selectedNeighbourhood.text(neighbourhoodName);


                setTimeout(() => {
                    fetchAnalysisData(neighbourhoodId, neighbourhoodName, false);
                }, 100);

                return false;
            }
        });


        if (!found) {
            selectedNeighbourhood.text("Cijeli grad");
            //fetchAnalysisData("", "Cijeli grad", false);
        }
    }


    if (neighbourhoodSelect) {
        neighbourhoodSelect.addEventListener("change", function () {
            const neighbourhoodId = this.value;
            const neighbourhoodName = this.options[this.selectedIndex].text;
            if (!neighbourhoodId || neighbourhoodId === "") {
                window.location.href = window.location.pathname;
                return;
            }
            fetchAnalysisData(neighbourhoodId, neighbourhoodName, false);
        });
    }
    const renderChart = (chartCanvas, chartType) => {
        const ctx = chartCanvas.getContext('2d');
        const pct = chartCanvas.dataset.pct === 'true';

        let chartConfig;

        if (chartType === 'double-bar') {
            const data = JSON.parse(chartCanvas.dataset.items);
            const labels = Object.keys(data);
            const cityData = labels.map(label => data[label].city);
            const neighbourhoodData = labels.map(label => data[label].neighbourhood);

            chartConfig = {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: [
                        {
                            label: 'Grad',
                            data: cityData,
                            backgroundColor: 'rgba(0, 159, 77, 0.2)',
                            borderColor: 'rgb(0, 159, 77)',
                            borderWidth: 1,
                            borderRadius: 5
                        },
                        {
                            label: 'Kvart',
                            data: neighbourhoodData,
                            backgroundColor: 'rgba(0, 132, 157, 0.2)',
                            borderColor: 'rgb(0, 132, 157)',
                            borderWidth: 1,
                            borderRadius: 5
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: true,
                            position: "bottom",
                            labels: {
                                padding: 30,
                                boxWidth: 20,
                                font: {
                                    size: 14,
                                },
                            },
                        },
                    },
                    animation: {
                        duration: 1000,
                        easing: "easeInOutCubic",
                    },
                }
            };
        } else if (chartType === 'categories-stacked') {
            // Special case for categories data with solved/unsolved stacked bars
            const data = JSON.parse(chartCanvas.dataset.items);
            const labels = data.map(item => item.name);
            const solvedData = data.map(item => item.solved);
            const unsolvedData = data.map(item => item.unsolved);

            chartConfig = {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: [
                        {
                            label: 'Riješeno',
                            data: solvedData,
                            backgroundColor: 'rgba(0, 159, 77, 0.8)',
                            borderColor: 'rgb(0, 159, 77)',
                            borderWidth: 1,
                            borderRadius: 5
                        },
                        {
                            label: 'Neriješeno',
                            data: unsolvedData,
                            backgroundColor: 'rgba(220, 53, 69, 0.8)',
                            borderColor: 'rgb(220, 53, 69)',
                            borderWidth: 1,
                            borderRadius: 5
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        x: {
                            stacked: true,
                        },
                        y: {
                            stacked: true,
                            beginAtZero: true
                        }
                    },
                    plugins: {
                        legend: {
                            display: true,
                            position: "bottom",
                            labels: {
                                padding: 30,
                                boxWidth: 20,
                                font: {
                                    size: 14,
                                },
                            },
                        },
                    },
                    animation: {
                        duration: 1000,
                        easing: "easeInOutCubic",
                    },
                }
            };
        } else if (chartType === 'monthly-line') {
            // Special case for monthly data as line chart
            const data = JSON.parse(chartCanvas.dataset.items);
            const labels = data.map(item => item.name);
            const counts = data.map(item => item.count);

            chartConfig = {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [{
                        label: 'Broj prijava',
                        data: counts,
                        backgroundColor: 'rgba(0, 159, 77, 0.2)',
                        borderColor: 'rgb(0, 159, 77)',
                        borderWidth: 3,
                        fill: true,
                        tension: 0.4,
                        pointBackgroundColor: 'rgb(0, 159, 77)',
                        pointBorderColor: 'rgb(0, 159, 77)',
                        pointRadius: 6,
                        pointHoverRadius: 8
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        y: {
                            beginAtZero: true,
                            grid: {
                                color: 'rgba(0, 0, 0, 0.1)'
                            }
                        },
                        x: {
                            grid: {
                                color: 'rgba(0, 0, 0, 0.1)'
                            }
                        }
                    },
                    plugins: {
                        legend: {
                            display: true,
                            position: "bottom",
                            labels: {
                                padding: 30,
                                boxWidth: 20,
                                font: {
                                    size: 14,
                                },
                            },
                        },
                    },
                    animation: {
                        duration: 1000,
                        easing: "easeInOutCubic",
                    },
                }
            };
        } else if (chartType === 'radar') {
            const data = JSON.parse(chartCanvas.dataset.items);
            chartConfig = {
                type: 'radar',
                data: data,
                options: {
                    responsive: false,
                    maintainAspectRatio: false,
                    scales: {
                        r: {
                            ticks: {
                                display: false
                            },
                            pointLabels: {
                                font: {
                                    size: 16
                                }
                            }
                        }
                    },
                    plugins: {
                        legend: {
                            position: "bottom",
                            labels: {
                                font: {
                                    size: 20,
                                },
                            },
                        },
                    },
                    animation: {
                        duration: 1000,
                        easing: "easeInOutCubic",
                    },
                }
            };
        } else {
            const data = JSON.parse(chartCanvas.dataset.items);
            const colors = chartCanvas.dataset.colors ? JSON.parse(chartCanvas.dataset.colors) : undefined;

            chartConfig = {
                type: chartType,
                data: {
                    labels: Object.keys(data),
                    datasets: [{
                        label: chartCanvas.dataset.label || 'Iznos',
                        data: Object.values(data),
                        backgroundColor: colors || 'rgba(0, 159, 77, 0.2)',
                        borderColor: colors ? colors.map(color => color.replace('rgba', 'rgb')) : 'rgb(0 159 77)',
                        borderWidth: 1,
                        borderRadius: 5
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: false,
                            position: "bottom",
                            labels: {
                                padding: 30,
                                boxWidth: 20,
                                font: {
                                    size: 20,
                                },
                            },
                        },
                        tooltip: {
                            callbacks: {
                                label: function (tooltipItem) {
                                    // Get the default label
                                    let label = Chart.defaults.plugins.tooltip.callbacks.label(tooltipItem);
                                    if (pct) {
                                        return label + '%';
                                    } else {
                                        return label
                                    }
                                }
                            }
                        }
                    },
                    animation: {
                        duration: 1000,
                        easing: "easeInOutCubic",
                    },
                }
            };
        }

        new Chart(ctx, chartConfig);
    };

    const setupObserversForCharts = (selector, chartType) => {
        document.querySelectorAll(selector).forEach(chartCanvas => {
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        renderChart(chartCanvas, chartType);
                        observer.disconnect();
                    }
                });
            });

            observer.observe(chartCanvas);
        });
    };

    const initializeCharts = () => {
        setupObserversForCharts("canvas.bar-chart", 'bar');
        setupObserversForCharts("canvas.line-chart", 'line');
        setupObserversForCharts("canvas.pie-chart", 'pie');
        setupObserversForCharts("canvas.radar-chart", 'radar');
        setupObserversForCharts("canvas.double-bar-chart", 'double-bar');

        // Special cases for your new chart types
        setupObserversForCharts("canvas#categories-chart", 'categories-stacked');
        setupObserversForCharts("canvas#monthly-chart", 'monthly-line');
    };

    // Run on initial page load
    initializeCharts();
});




